<template>
  <div class="packages-overview-results-list">

    <InlineSvg v-show="loading"
               src="@/assets/images/icons/loading.svg"
               class="packages-overview-results-list__loader"
               />

    <ul v-if="packages.length > 0"
        :class="itemsClasses"
    >

      <li v-for="packageData in packages"
          :key="packageData.id"
          class="packages-overview-results-list-items__item"
      >

        <figure
          class="packages-overview-results-list-items__figure"
          data-saved-package-parent-container
        >

          <ul class="packages-overview-results-list-items__labels"
              v-if="packageData.flags.length > 0"
          >

            <li v-for="(flag, index) in packageData.flags"
                :key="index"
                :class="[
                  'packages-overview-results-list-items__label',
                  `packages-overview-results-list-items__label--${flag.type.toLowerCase()}`,
                ]
            ">
              {{ flag.title }}
            </li>

          </ul>

          <div class="packages-overview-results-list-items__image-container">

            <aside
              class="saved-package-corner"
              data-saved-package
              :data-id="packageData.id"
              :data-site-id="packageData.siteId"
              :data-saved="packageData.isSaved"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                class="saved-package-corner__icon"
              >
                <!--! Font Awesome Pro 6.0.0 by @@fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.-->
                <g class="saved-package-corner__icon-group saved-package-corner__icon-group--solid">
                  <!-- eslint-disable-next-line -->
                  <path d="M0 190.9v-5.8c0-69.9 50.52-129.52 119.4-141 44.7-7.59 92 7.27 124.6 39.92L256 96l11.1-11.98C300.6 51.37 347 36.51 392.6 44.1c68.9 11.48 119.4 71.1 119.4 141v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.59 300.4C17.23 272.1 0 232.4 0 190.9z" />
                </g>
                <!-- eslint-disable-next-line -->
                <g class="saved-package-corner__icon-group saved-package-corner__icon-group--outline">
                  <!-- eslint-disable-next-line -->
                  <path d="m244 84 11.1 12 12-11.98C300.6 51.37 347 36.51 392.6 44.1c68.9 11.48 119.4 71.1 119.4 141v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.59 300.4C17.23 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.52-129.52 119.4-141 44.7-7.59 92 7.27 124.6 39.9-.9 0 0 .01 0 0zm11.1 79.9-45-46.8c-21.7-20.82-52.5-30.7-82.8-25.66C81.55 99.07 48 138.7 48 185.1v5.8c0 28.2 11.71 55.2 32.34 74.4L256 429.3l175.7-164c20.6-19.2 32.3-46.2 32.3-74.4v-5.8c0-46.4-33.6-86.03-79.3-93.66-30.3-5.04-61.1 4.84-82.8 25.66l-46.8 46.8z" />
                </g>
              </svg>
            </aside>

            <img
              :src="formatImageSrc(packageData.imageUrl)"
              :srcset="formatImageSrcset(packageData.imageUrl)"
              :sizes="formatImageSizes()"
              :alt="packageData.title"
              class="packages-overview-results-list-items__image"
              loading="lazy"
            />

          </div>

          <figcaption class="packages-overview-results-list-items__caption">

            <h3 class="packages-overview-results-list-items__title">
              {{ packageData.title }}
            </h3>

            <div class="packages-overview-results-list-items__description">

              <ul class="packages-overview-results-list-items__usps"
                  v-if="packageData.usps.length > 0"
              >

                <li v-for="(usp, index) in packageData.usps"
                    :key="index"
                    class="packages-overview-results-list-items__usp-item"
                >

                  <img :src="usp.icon"
                       :alt="usp.title"
                       class="packages-overview-results-list-items__usp-icon"
                       />

                  <span class="packages-overview-results-list-items__usp-text">
                    {{ usp.title }}
                  </span>

                </li>

              </ul>

              <div
                v-if="packageData.startPrice"
                class="packages-overview-results-list-items__price"
              >

                <span class="packages-overview-results-list-items__price-prefix">
                  Vanaf p.p.
                </span>

                <span class="packages-overview-results-list-items__price-amount">
                  &euro;&nbsp;{{ packageData.startPrice }},-
                </span>

              </div>

            </div>

            <a :href="packageData.url"
               class="button packages-overview-results-list-items__button"
            >
              Reis bekijken
            </a>

          </figcaption>

        </figure>

      </li>

    </ul>

    <figure v-else
            :class="messageClasses"
    >

      <InlineSvg src="@/assets/images/icons/map-marked-alt.svg"
                 class="packages-overview-results-list-message__image"
                 />

      <figcaption class="packages-overview-results-list-message__caption">

        <h3 class="packages-overview-results-list-message__title">
          Geen reizen gevonden
        </h3>

        <p class="packages-overview-results-list-message__text">
          Er zijn geen reizen gevonden die aan jouw filters voldoen.<br />
          Pas de filters aan om meer reizen te vinden!
        </p>

        <Button icon="@/assets/images/icons/undo-alt.svg"
                class="packages-overview-results-list-message__button"
                @click="$emit('resetFilters')"
        >
          Begin opnieuw
        </Button>

      </figcaption>

    </figure>

  </div>
</template>

<script>
const IMAGE_SIZES = {
  320: 273,
  375: 328,
  425: 378,
  768: 360,
  1024: 336,
  1440: 432,
};
// eslint-disable-next-line
import api from '@/api';

// eslint-disable-next-line
import Button from '@/components/UI/Button.vue';
// eslint-disable-next-line
import InlineSvg from '@/components/UI/InlineSvg.vue';

export default {
  name: 'ResultsList',

  components: {
    Button,
    InlineSvg,
  },

  props: {
    activeFilters: {
      type: Object,
      required: true,
    },
    amountPerPage: {
      type: Number,
      required: true,
    },
    filtersLoaded: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    page: {
      type: Number,
    },
    pageLoaded: {
      type: Boolean,
      required: true,
    },
    siteId: {
      type: Number,
      required: true,
    },
    sortOrder: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    packages: [],
  }),

  computed: {
    amountOffset() {
      return this.amountPerPage * (this.page - 1);
    },

    itemsClasses() {
      return [
        'packages-overview-results-list-items',
        { 'packages-overview-results-list-items--loading': this.loading },
      ];
    },

    messageClasses() {
      return [
        'packages-overview-results-list-message',
        { 'packages-overview-results-list-message--loading': this.loading },
      ];
    },
  },

  watch: {
    activeFilters: {
      deep: true,
      handler: 'resetPageOrUpdatePackages',
    },

    filtersLoaded: 'updatePackages',

    page: 'updatePackages',

    pageLoaded: 'updatePackages',

    sortOrder: 'resetPageOrUpdatePackages',
  },

  methods: {
    dispatchVueLoaded() {
      document.dispatchEvent(new Event('VueContentLoaded'));
    },

    formatImageSizes() {
      return Object.entries(IMAGE_SIZES)
        .map(([breakpoint, size], index) => {
          let formattedSize = '';

          if (index + 1 !== IMAGE_SIZES.length) {
            formattedSize += `(max-width: ${breakpoint}px) `;
          }

          formattedSize += `${size}px`;
          return formattedSize;
        })
        .join(', ');
    },

    formatImageSrc(path) {
      return `${path}?format=webp`;
    },

    formatImageSrcset(path) {
      return Object.values(IMAGE_SIZES)
        .map((size) => `${path}?format=webp&width=${size} ${size}w`)
        .join(', ');
    },

    resetPageOrUpdatePackages() {
      if (
        this.page !== 1
        && this.filtersLoaded
        && this.pageLoaded
      ) {
        this.$emit('update:page', 1);
        return;
      }

      this.updatePackages();
    },

    updatePackages() {
      if (!this.filtersLoaded || !this.pageLoaded) {
        return;
      }

      this.$emit('update:loading', true);

      api.getPackages(
        this.siteId,
        this.activeFilters,
        this.amountPerPage,
        this.amountOffset,
        this.sortOrder,
      )
        .then((response) => {
          const {
            hits,
            totalResults,
          } = response.data;

          this.$emit('setAmount', parseInt(totalResults, 10));
          this.packages = hits;
        })
        .catch((error) => {
          console.error(error);
        })
        .then(() => {
          this.$emit('update:loading', false);
          /* eslint-disable no-undef */
          if (typeof lazyLoadInstance !== 'undefined') {
            lazyLoadInstance.update();
          }
          /* eslint-enable no-undef */
          this.dispatchVueLoaded();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/css/helpers/mixins/breakpoints';

  @mixin loading {
    transition-property: filter, opacity;
    transition-duration: .4s;

    &--loading {
      filter: blur(5px);
      opacity: .5;
      pointer-events: none;
      transition-duration: 1s;
    }
  }

  .packages-overview-results-list {
    --padding: var(--spacing-m);

    @include laptop-and-larger {
      --padding: 0;
    }

    position: relative;
    padding: 0 var(--padding);

    &__loader {
      --height: 4rem;

      position: absolute;
      top: 5vh;
      left: calc(50% - (var(--height) / 2));
      height: var(--height);
      z-index: 1;
      color: var(--color-primary);
      animation: spin 1s linear infinite;
    }

    &-items {
      @include loading;
      list-style: none;

      &__item {
        padding: var(--spacing-l) 0 var(--spacing-m);
        margin: 0;
        border-bottom: 1px solid var(--color-divider);

        @include tablet-and-larger {
          padding-bottom: var(--spacing-l);
        }
      }

      &__figure {
        position: relative;
        margin: 0;

        @include tablet-and-larger {
          display: flex;
        }
      }

      &__labels {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        list-style: none;
      }

      &__label {
        padding: 7px 10px;
        margin: 0;
        background-color: var(--color-primary);
        color: white;
        font-size: 13px;
        line-height: 16px;
        font-weight: 700;
        text-transform: uppercase;

        &--secondary {
          background-color: var(--color-secondary);
        }
      }

      &__image {
        display: block;

        &-container {
          position: relative;
          overflow: hidden;
          margin-bottom: 8px;

          @include tablet-and-larger {
            flex-shrink: 0;
            width: 50%;
            margin: 0 var(--spacing-m) auto 0;
          }
        }
      }

      &__caption {
        display: flex;
        flex-direction: column;

        @include tablet-and-larger {
          flex-grow: 1;
        }
      }

      &__title {
        width: 100%;
        font-size: 18px;
        line-height: 1.2;
        margin-bottom: 8px;

        @include tablet-and-larger {
          font-size: 24px;
        }
      }

      &__description {
        display: flex;
        flex-grow: 1;
        margin-bottom: var(--spacing-m);
      }

      &__usps {
        flex-grow: 1;
        list-style: none;
      }

      &__usp {

        &-item {
          display: flex;
          padding: 2px 0;
          margin: 0;

          @include tablet-and-larger {
            padding: 5px 0;
          }

          &:nth-child(n + 5) {

            @include mobile-only {
              display: none;
            }
          }
        }

        &-icon {
          flex-shrink: 0;
          height: 17px;
          image-rendering: -webkit-optimize-contrast;
        }

        &-text {
          margin-left: .75ch;
          font-size: 14px;
          line-height: 17px;
        }
      }

      &__price {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex-shrink: 0;
        padding-left: var(--spacing-m);
        margin: auto 0 0 auto;
        font-size: 12px;

        &-prefix {
          color: #999;
        }

        &-amount {
          color: var(--color-primary);
          font-size: 2em;
          font-weight: bold;
        }
      }

      &__button {
        text-align: center;

        @include mobile-only {
          width: 100%;
          font-size: 14px;
        }

        @include tablet-and-larger {
          margin-left: auto;
        }

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
      }
    }

    &-message {
      @include loading;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 5vh 0;
      margin: 0;

      &__image {
        height: 4rem;
        margin-bottom: 2em;
        animation: no-result-image 1s ease infinite alternate;
      }

      &__caption {
        text-align: center;
      }

      &__text {
        font-size: 18px;
        line-height: 1.5;
        margin-bottom: 2em;
      }

      &__button {
        background-color: var(--color-primary);
      }
    }
  }
</style>
